import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiPatch } from '../api/client.js';

export const usePointsOfSale = (clientId) =>
  useQuery({
    queryKey: ['points-of-sale', clientId],
    queryFn: () => apiGet(`/clients/${clientId}/points-of-sale`),
    enabled: !!clientId,
  });

export const useCreatePos = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost(`/clients/${clientId}/points-of-sale`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['points-of-sale', clientId] }),
  });
};

export const useUpdatePos = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ posId, ...data }) => apiPatch(`/clients/${clientId}/points-of-sale/${posId}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['points-of-sale', clientId] }),
  });
};

export const useSyncPos = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ posId, environment }) => apiPost(`/clients/${clientId}/points-of-sale/${posId}/sync`, { environment }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['points-of-sale', clientId] }),
  });
};
